/**
 * Properly decodes base64 data URL to UTF-8 string
 * Handles UTF-8 characters that atob() cannot process correctly
 */
export const decodeBase64ToUtf8 = (dataUrl: string): string => {
  if (!dataUrl) return "";

  // Remove data URL prefix (e.g., "data:text/vtt;base64,")
  const base64Data = dataUrl.replace(/data:\S+,/, "");

  try {
    // Decode base64 to binary string
    const binaryString = atob(base64Data);

    // Convert binary string to UTF-8
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Decode UTF-8 bytes to string
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(bytes);
  } catch (error) {
    console.error("Failed to decode base64 data:", error);
    return "";
  }
};
